import React, { useState,useRef } from 'react';

import {Box,  Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { Typography } from '@mui/material';
import { logo } from "../utils/constants";
import { SearchBar } from "./";

import MenuIcon from '@mui/icons-material/Menu';


// import {menu} from

const boxSx = {
  borderRadius:"10px",
  cursor:"pointer", 
  width:"30px", 
  height:"43px", 
  color: "white" ,
  justifyContent: "center",
  "&:hover":{
  backgroundColor:"#A0A0A0",
  
}}


const Navbar = ({setSelectedCategory,menuIcon,showSidebar}) => {
  
  
  
  return(
  <Stack direction="row" alignItems="center" p={2} sx={{ position:  "sticky", background: '#000', top: 0, justifyContent: "space-between" }}>
    <Stack marginLeft="10px" direction="row"  alignItems="center" sx={{ justifyContent: "center",gap: "15px"}}>
      <Box onClick={(e)=>showSidebar(e)} sx={{className:"menuIcon", borderRadius:"50%","&:hover": { backgroundColor:"#A0A0A0" } }}>
        <MenuIcon  ref={menuIcon}  style={{borderRadius:"10px",cursor:"pointer", width:"30px", height:"30px", color: "white" ,justifyContent: "center","&:hover": { backgroundColor:"#A0A0A0" } }}/>

      </Box>
      <Link to="/" style={{ textDecoration:"none",display: "flex", alignItems: "center" }}>
        <Stack direction="row"  alignItems="center" gap="5px" >
          
            <img src={logo} alt="logo" height={45} />
            
          

          <Typography align = "center" color = "white"   sx={{  fontSize: "25px" ,fontWeight:"bold"}}>
              <span style = {{color:"red"}}>R</span>Tube
          </Typography>


        </Stack>
      </Link>

    </Stack>
    
    <Stack direction="row" width="70%" justifyContent="start" alignItems="left">
      <SearchBar setSelectedCategory={setSelectedCategory}/>
    </Stack>
    
  </Stack>
)};

export default Navbar;